export default {
  singleLabel: "Environnement de stockage",
  storeNamespace: 'storage_environment',
  authFeature: 'storage-environment',
  listRouteName: "StorageEnvironmentList",
  newRouteName: "StorageEnvironmentNew",
  editRouteName: "StorageEnvironmentEdit",
  detailRouteName: "StorageEnvironmentDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'StorageEnvironmentForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'name',
  sortBy: 'name',
  showExtendedFilters: true,
  fields: [{
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: false,
    },
    {
      // Champ de formulaire seul : l'entrepôt d'un environnement est celui de sa zone, il ne
      // sert qu'à filtrer les zones proposées.
      name: 'warehouse_id',
      label: "Entrepôt",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
    },
    {
      name: 'warehouse',
      label: "Entrepôt",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      extendedFilter: true,
      inDetail: true,
      detailLink: 'WarehouseDetail',
      formatter: (context, value) => value && value.name ? [value.internal_code, value.name].filter(Boolean).join(' - ') : null
    },
    {
      name: 'storage_zone_id',
      label: "Zone de stockage",
      type: 'select',
      inForm: true,
      required: true,
      firstOption: "-- Sélectionnez un entrepôt --",
      inList: false,
      inDetail: false,
    },
    {
      name: 'storage_zone',
      label: "Zone de stockage",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      detailLink: 'StorageZoneDetail',
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'parent_storage_environment_id',
      label: "Environnement de stockage parent",
      type: 'select',
      inForm: true,
      firstOption: "-- Sélectionnez une zone de stockage --",
      inList: false,
      inDetail: false,
    },
    {
      name: 'parent_storage_environment',
      label: "Environnement de stockage parent",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      detailLink: 'StorageEnvironmentDetail',
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'storage_type_id',
      label: "Type de stockage",
      type: 'select',
      inForm: true,
      required: false,
      inList: false,
      inDetail: false,
    },
    {
      name: 'storage_type',
      label: "Type de stockage",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      extendedFilter: true,
      inDetail: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'internal_code',
      label: "Code interne",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/StorageEnvironment/config.js